import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox, Spin } from 'antd';
import TreeTitle from '../components/Tree/treeTitle';
import TreeCanvas from '../components/Tree_v2/canvas';
import {
  updatePinSelectPanelId,
  updateTreeLoading,
  updateDrawType,
  deleteTreeItem,
  delDesignTree,
  updatePowerTreeV2
} from '../store/DesignTree/action';
import { selectChange, changeShowNameStatus, selectLayer } from '../../LayoutExplorer/store/Cascade/actionCreators';
import { NetGroupSelection } from '@/services/PCBHelper';
import { getSelectedDesignIDs } from '@/services/helper/dataProcess';
import canvas from '@/services/LayoutCanvas';
import { DESIGN_TREE, POWER_TREE, SINGLE_TREE } from '../../../constants/treeConstants';
import html2canvas from 'html2canvas';
import { downloadFile } from '../../../services/helper/downloadHelper';
import { getCascadeComponents } from '../../../services/Cascade/helper/setupData';
import { tracePaths } from '../../../services/Cascade/PowerTree';
import { IGNORE, LOAD } from '../../../constants/componentType';
import { saveComponentAsConnector } from '../store/PowerTree/action';
import './index.css';

class DesignTree extends Component {
  constructor(props) {
    super(props);
    const { data = {}, viewList, number } = props;
    const { id, tree = {} } = data;
    this.state = {
      id: id,
      tree: tree,
      width: 1000,
      drawStatus: false,
      showCanvas: tree.deep < 40 || number === 1 ? true : false,
      shot: false,
      applyTo: viewList.includes(POWER_TREE) ? true : false
    }
    this.netGroupSelection = new NetGroupSelection();
  }

  componentDidMount() {
    this.getCanvansWidth();
    window.addEventListener('resize', this.getCanvansWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.getCanvansWidth);
  }

  componentDidUpdate = (prevProps) => {
    const { draw, data, reset, number } = this.props;
    if (data.id && draw[data.id]) {
      this.props.updateDrawType(data.id, false);
      const { showCanvas, tree = {} } = this.state;
      this.setState({
        id: data.id,
        tree: data.tree,
        drawStatus: true,
        showCanvas: tree.deep === 0 ? data.tree.deep > 40 || number > 1 ? false : true : showCanvas
      }, () => {
        this.getCanvansWidth();
      });
    }

    if (reset !== prevProps.reset) {
      this.setState({
        id: data.id,
        tree: data.tree,
        drawStatus: true
      }, () => {
        this.getCanvansWidth();
      });
    }
  }

  getCanvansWidth = () => {
    const { id } = this.state;
    const ele = document.getElementById(`power-tree-layout-${id}`);
    const offset = ele ? ele.getBoundingClientRect() : null;
    this.setState({
      width: offset && offset.width ? offset.width : 1000
    })
  }

  changeTreeName = (name) => {
    const { id } = this.state;
    this.props.updateCurrentTree('name', { id, name });
    this.updateTree({ name });
  }

  updateTree = (treeItem) => {
    const { tree } = this.state;
    this.setState({
      tree: {
        ...tree,
        ...treeItem
      }
    })
  }

  updateDraw = (drawStatus) => {
    this.setState({ drawStatus });
  }

  saveTreeItemValue = (value, type, itemId, columnIndex) => {
    const { id, tree, applyTo } = this.state;
    const { branch } = tree;
    const _branch = [...branch];
    const findIndex = _branch[columnIndex].findIndex(item => item.id === itemId);
    if (findIndex > -1) {
      _branch[columnIndex][findIndex][type] = value;
      const { name, pcbKey, type: compType } = _branch[columnIndex][findIndex];
      if (applyTo) {
        _branch.forEach(column => {
          column.forEach(item => {
            if (item.name === name && item.pcbKey === pcbKey && item.type === compType) {
              item[type] = value
            }
          })
        })
      }
      this.updateTree({ branch: _branch });
      this.props.updateCurrentTree('value', { id, itemId, applyTo, value, type })
    }
  }

  saveConnectorTreeItemValue = (value, net, itemId, columnIndex) => {
    const { id, tree, applyTo } = this.state;
    const { branch } = tree;
    const _branch = [...branch];
    const findIndex = _branch[columnIndex].findIndex(item => item.id === itemId);
    if (findIndex > -1) {
      const resIndex = _branch[columnIndex][findIndex].resistances.findIndex(item => item.net === net);
      if (resIndex > -1) {
        _branch[columnIndex][findIndex].resistances[resIndex].resistance = value
        const { name, pcbKey, type: compType } = _branch[columnIndex][findIndex];
        if (applyTo) {
          _branch.forEach(column => {
            column.forEach(item => {
              if (item.name === name && item.pcbKey === pcbKey && item.type === compType) {
                const resIndex = item.resistances.findIndex(item => item.net === net);
                if (resIndex > -1) {
                  item.resistances[resIndex].resistance = value
                }
              }
            })
          })
        }
        this.updateTree({ branch: _branch });
        this.props.updateCurrentTree('connectorValue', { id, itemId, applyTo, value, net })
      }
    }
  }

  showTreeAction = (id, showPath = false) => {
    const { tree } = this.state;
    const { branch, pcbIndex, paths } = tree;
    const _branch = branch.flat(2);
    const item = _branch.find(item => item.id === id);
    if (item) {
      let comps = [], nets = [];
      const { pcbKey, ids } = item;
      const pcb = pcbIndex.find(item => item.key === pcbKey) || {};
      const designId = pcb.pcbId;
      if (showPath) {
        const pcbPaths = paths[pcbKey];
        const { paths: powerPaths, gndPaths } = pcbPaths;
        const items = [...powerPaths, ...gndPaths].filter(path => {
          if (path.some(item => ids.includes(item.id))) {
            return true;
          }
          return false
        }).map(path => path.filter(item => item.pcbKey === pcbKey)).flat();
        comps.push(...items.map(item => item.name));
        nets.push(...items.map(item => item.nextNet));
      } else {
        comps.push(item.name);
      }
      this.showTree({ comps, nets, designId })
    }
  }

  showTree = ({ comps, nets, designId }) => {
    const { selectedIds } = this.props;
    if (!selectedIds.includes(designId)) {
      return;
    }
    const _nets = [...new Set(nets)].filter(item => !!item), _comps = [...new Set([...comps])].filter(item => !!item);
    const layout = canvas.getLayout(designId);
    let layers = layout.findCurrentLayer(comps);
    layers = [...new Set(layers)];
    this.props._selectLayer(layers, designId);
    this.props._selectChange({ nets: _nets, comps: _comps }, designId)
    this.props._changeShowNameStatus(true, designId)
    setTimeout(() => {
      this.netGroupSelection.selectNetGroup({ nets: _nets, isPower: true })
    }, 100);
  }

  updateShowCanvas = () => {
    this.setState({
      showCanvas: !this.state.showCanvas
    }, () => {
      const { showCanvas } = this.state;
      if (showCanvas) {
        this.getCanvansWidth()
      }
    })
  }

  deletePowerTree = (e) => {
    e && e.stopPropagation();
    const { id } = this.state;
    this.props.delDesignTree(id);
  }

  changePCBIndexColor = (e, index) => {
    const color = e.target.value;
    const { tree, id } = this.state;
    const { pcbIndex } = tree;
    let _pcbIndex = [...pcbIndex];
    _pcbIndex[index].color = color;
    this.props.updateCurrentTree('pcbIndex', { id, pcbIndex: _pcbIndex });
  }

  translateToCanvas = (id, name) => {
    this.setState({
      showCanvas: true,
      shot: true
    }, () => {
      setTimeout(() => {
        const ele = document.getElementById(`power-tree-${id}`);
        const canvas = this.canvasRef.getCanvas();
        const config = {
          width: canvas.scrollWidth,
          windowWidth: canvas.scrollWidth + 400,
          scale: 1
        }
        html2canvas(ele, config).then(canvas => {
          downloadFile(canvas, name, 'canvas');
        })
        this.setState({
          shot: false
        })
      }, 500)
    })
  }

  changeApplyTo = (e) => {
    this.setState({
      applyTo: e.target.checked
    })
  }

  setCanvasRef = (ref) => {
    this.canvasRef = ref;
  }

  changeWhatIf = (newWhatIf) => {
    const { id, tree } = this.state;
    this.setState({
      tree: {
        ...tree, whatIf: newWhatIf
      }
    })
    this.props.updateCurrentTree('whatIf', { id, whatIf: newWhatIf })
  }

  saveWhatIfData = (pair, ifValue, pcbKey) => {
    const { tree, id } = this.state;
    const { whatIfData = [] } = tree;
    let _whatIfData = [...whatIfData];
    if (!ifValue) {
      _whatIfData = _whatIfData.filter(data =>
        !(data.pcbKey === pcbKey &&
          data.componentIn === pair.componentIn &&
          data.componentOut === pair.componentOut &&
          data.pinIn === pair.pinIn &&
          data.pinOut === pair.pinOut))
    } else {
      const findIndex = _whatIfData.findIndex(data =>
        data.pcbKey === pcbKey &&
        data.componentIn === pair.componentIn &&
        data.componentOut === pair.componentOut &&
        data.pinIn === pair.pinIn &&
        data.pinOut === pair.pinOut)
      if (findIndex > -1) {
        _whatIfData[findIndex].ifValue = ifValue;
      } else {
        _whatIfData.push({ ...pair, pcbKey, ifValue })
      }
    }
    this.setState({
      tree: {
        ...tree, whatIfData: _whatIfData
      }
    })
    this.props.updateCurrentTree('whatIfData', { id, whatIfData: _whatIfData })
  }

  deleteTreeItem = (itemId) => {
    const { id } = this.state;
    this.props.updateCurrentTree('delete', { id, itemId });
  }

  editTreeItem = (itemId, data) => {
    const { id } = this.state;
    this.props.updateCurrentTree('edit', { id, itemId, data });
  }

  refreshSinglePowerTree = () => {
    const { id } = this.state;
    this.props.updateCurrentTree('refresh', { id });
  }

  setTreeItemAsConnector = (name, pcbKey) => {
    this.props.saveComponentAsConnector(name, pcbKey)
  }

  traceByComponent = async (prevId, nextComp, prevNet, designId) => {
    const { tree } = this.state;
    const { paths, branch = [] } = tree;
    const { useInput } = this.props;
    const comp = getCascadeComponents({ pcbId: designId, name: nextComp });
    const powerNets = [...new Set([...comp.pins.values()].map(item => item.net))].filter(net => net !== prevNet);
    const treeItem = branch.flat().find(item => item.id === prevId);
    const pcbKey = treeItem.pcbKey;
    const pcbPaths = paths[pcbKey];
    const filterPaths = [...pcbPaths.paths, ...pcbPaths.gndPaths].map(path => {
      const findIndex = path.findIndex(item => treeItem.ids.includes(item.id));
      if (findIndex > -1) {
        return path.slice(0, findIndex + 1);
      }
      return null
    }).filter(item => !!item);
    const filterNets = filterPaths.map(path => path.map(item => ([item.prevNet, item.nextNet]))).flat();
    const newPaths = await tracePaths({
      powerTreeLevel: 5,
      useInput,
      designId,
      key: pcbKey,
      compName: nextComp,
      powerNets: comp.type === IGNORE || comp.type === LOAD ? [powerNets.length ? powerNets[0] : ''] : powerNets,
      groundNets: [],
      filterNets: filterNets,
      edit: true
    })
    return [...newPaths]
  }

  render() {
    const {
      loading, treeLoading, viewList, selectedIds, running, showResult, connectors,
      includeInd, spiceSimulation, setting, version, resultStatus, treeInfo
    } = this.props;
    const { tree, id, width, drawStatus, showCanvas, shot, applyTo } = this.state;
    const { name, root, branch = [], deep, pcbIndex, logs, whatIf = false, whatIfData = [], mainPCB } = tree;
    const designIds = pcbIndex.map(item => item.pcbId);
    const showLayout = viewList.length > 1 && selectedIds.some(id => designIds.includes(id)) ? true : false;
    const view = viewList.find(item => [POWER_TREE, DESIGN_TREE, SINGLE_TREE].includes(item));
    return <div className={`cascade-power-tree-main ${showCanvas && !branch.length ? 'cascade-power-tree-main-loading-no-canvas' : ''}`} style={{ minHeight: showCanvas ? 100 : 'unset' }}>
      <Spin spinning={loading || treeLoading[id] || shot ? true : false} tip={shot ? 'Saving screenshot...' : treeLoading[id]}>
        <div className='cascade-power-tree-name-edit' style={showCanvas ? {} : { borderBottom: '0px', paddingBottom: '0px' }}>
          <TreeTitle
            changeTreeName={this.changeTreeName}
            name={name}
            showCanvas={showCanvas}
            updateShowCanvas={this.updateShowCanvas}
            couldDel={true}
            deletePowerTree={this.deletePowerTree}
            logs={logs}
            screenShot={() => this.translateToCanvas(id, name)}
            whatIf={whatIf}
            changeWhatIf={this.changeWhatIf}
            spiceSimulation={spiceSimulation[id] || false}
            version={version}
            refreshSinglePowerTree={this.refreshSinglePowerTree}
            treeInfo={treeInfo}
          />
        </div>
        {view === POWER_TREE && <div className='cascade-power-tree-apply-to'>
          <Checkbox
            style={{ marginRight: 18 }}
            checked={applyTo}
            onChange={this.changeApplyTo}
          />
          <span>Apply value to components with the same name</span>
        </div>}
        {showCanvas ?
          branch.length ?
            <TreeCanvas
              id={id}
              canvasRef={this.setCanvasRef}
              root={root}
              branch={branch}
              deep={deep}
              width={width}
              drawStatus={drawStatus}
              showLayout={showLayout}
              updateTreeLoading={this.props.updateTreeLoading}
              updateDrawType={this.updateDraw}
              saveTreeItemValue={this.saveTreeItemValue}
              saveConnectorTreeItemValue={this.saveConnectorTreeItemValue}
              showTreeAction={this.showTreeAction}
              running={running}
              showResult={showResult}
              pcbIndex={pcbIndex}
              colorChange={this.changePCBIndexColor}
              connections={connectors}
              shot={shot}
              includeInd={includeInd}
              whatIf={whatIf}
              whatIfData={whatIfData}
              saveWhatIfData={this.saveWhatIfData}
              setting={setting}
              mainPCB={mainPCB}
              deleteTreeItem={this.deleteTreeItem}
              traceByComponent={this.traceByComponent}
              editTreeItem={this.editTreeItem}
              setTreeItemAsConnector={this.setTreeItemAsConnector}
              resultStatus={resultStatus}
            /> : null
          : null}
      </Spin>
    </div>
  }
}

const mapState = (state) => {
  const { CascadeReducer: {
    DesignTree: { treeLoading, draw, designId, reset, running, results, showResult, option = {}, spiceSimulation, setting, version, resultStatus, treeInfo },
    project: { viewList, selectedKeys },
    PowerTree: { root: { pcbId: rootPCBId = "" }, connectors = [] }
  } } = state;
  const rootPCBKey = connectors.length ? connectors[0] && connectors[0].length ? connectors[0][0].key : '' : '';
  const { includeInd = true, useInput } = option;
  return {
    treeLoading,
    draw,
    designId,
    viewList,
    selectedIds: getSelectedDesignIDs(selectedKeys),
    reset,
    running,
    results,
    showResult,
    rootPCBId,
    rootPCBKey,
    connectors,
    includeInd,
    spiceSimulation,
    setting,
    useInput,
    version,
    resultStatus,
    treeInfo
  };
}

const mapDispatch = (dispatch) => ({
  updateCurrentTree(key, params) {
    dispatch(updatePowerTreeV2(key, params))
  },
  updatePinSelectPanelId(id) {
    dispatch(updatePinSelectPanelId(id))
  },
  updateTreeLoading(id, tip) {
    dispatch(updateTreeLoading(id, tip));
  },
  updateDrawType(id, bool) {
    dispatch(updateDrawType(id, bool));
  },
  _changeShowNameStatus(status, designId) {
    dispatch(changeShowNameStatus(status, designId))
  },
  _selectLayer(layers, designId) {
    dispatch(selectLayer(layers, designId))
  },
  _selectChange(obj = {}, designId) {
    dispatch(selectChange(obj, designId))
  },
  deleteTreeItem(id, item, columnIndex) {
    dispatch(deleteTreeItem(id, item, columnIndex))
  },
  delDesignTree(id) {
    dispatch(delDesignTree(id))
  },
  saveComponentAsConnector(name, pcbKey) {
    dispatch(saveComponentAsConnector(name, pcbKey))
  }
})

export default connect(mapState, mapDispatch)(DesignTree);